import IService from '../IService';

export default IService.extend({
  initialize: function () {
    this.$ajaxFind = null;
  },

  abort: function () {
    if (app.xhrExpected(this.$ajaxFind)) {
      this.$ajaxFind.abort();
    }
  },

  find: function (params) {
    params.isAudio = true;

    const rv = new _.ColdPromise();

    this.$ajaxFind = $.ajax({
      url: app.apiUrl('/api/v1/assets'),
      type: 'GET',

      contentType: 'application/json',
      data: params,

      error: function (jqXHR, textStatus) {
        if (textStatus !== 'abort') {
          rv.reject({ error: textStatus });
        }
      },

      dataType: 'json',
      success: function (response) {
        if (
          _.isPlainObject(response) &&
          /* WTF ahead: FAILED_SEARCHING_ASSETS apparently is empty result set */
          /OK|FAILED_SEARCHING_ASSETS/.test(response.response)
        ) {
          // filter-out bad assets response
          const assets = _.filter(response.assets, function (asset) {
            return !!asset.hiResAssetUrl;
          });
          rv.resolve(assets);
        } else {
          rv.reject({ error: 'BAD_FORMAT' });
        }
      },
    }).always(() => {
      this.$ajaxFind = null;
    });

    return rv;
  },

  favorite: function (assetId, isFavorite) {
    const rv = new _.ColdPromise();

    $.ajax({
      url: app.apiUrl(`/api/v1/assets/${assetId}/favorite`),
      contentType: 'application/json',
      data: JSON.stringify({ favorite: !!isFavorite }),
      type: 'PUT',

      error: function (jqXHR, textStatus) {
        if (textStatus !== 'abort') {
          rv.reject({ error: textStatus });
        }
      },

      success: function (response) {
        rv.resolve(response);
      },
    });

    return rv;
  },

  delete: function (assetId) {
    const rv = new _.ColdPromise();

    $.ajax({
      url: app.apiUrl(`/api/v1/assets/${assetId}`, { _: $.now() }),
      async: true,
      method: 'DELETE',

      error: function (jqXHR, textStatus, errorThrown) {
        if (textStatus !== 'abort') {
          rv.reject(errorThrown);
        }
      },

      success: function (/* no-response*/) {
        rv.resolve();
      },
    });

    return rv;
  },
});
